/* src/app/private/components/user/signature-model/signature-model.component.scss */
/*# sourceMappingURL=signature-model.component.css.map */
